/* IBM Confidential‌ - OCO Source Materials‌ - (C) COPYRIGHT IBM CORP. 2020-2021 - The source code for this program is not published or otherwise‌ divested of its trade secrets, irrespective of what has been‌ deposited with the U.S. Copyright Office. */

import React, { Component } from "react";
import { NavConfig } from "../utils";
import "../nav/NavMain.scss";


class LandingPage extends Component {

  constructor(props) {
    super(props);
    this.triNavigationRef = React.createRef();
    this.isPreviousUrlSameOrBlank = false;
    this.isFromNavClick = false;
    this.isFromBrowserAction = false;
    this.urlHashPart = "";
    this.isInLineUXApp = false;
    this.isOnChangeProcessingComplete = false;
  }

  shouldComponentUpdate(nextProps) {
    if (nextProps.isFromNavClick) {
      return true;
    }
    return false;
  }

  componentDidUpdate(prevProps) {

    //This will determine if landing page show logic should be called onpopstate.
    this.isPreviousUrlSameOrBlank = this._isPreviousUrlSameOrBlank(prevProps);

    //Handle frame source
    this._handleNavFrameSource();
    //Set vertical scroll to top of page
    window.scrollTo(0,0);
  }

  _isPreviousUrlSameOrBlank(prevProps) {
    return prevProps.triNavigationSrc === '' || this.props.triNavigationSrc === prevProps.triNavigationSrc;
  }

  _handleNavFrameSource() {
    if (this.triNavigationRef.current) {
      this.isOnChangeProcessingComplete = false;
      this.isFromNavClick = this.props.isFromNavClick;
      this.urlHashPart = this.props.currentMenuItemPropertyModel.getUrlHashPart();
      this.isFromBrowserAction = this.props.currentMenuItemPropertyModel.isFromBrowserAction();
      this.isInLineUXApp = this.props.currentMenuItemPropertyModel.isInLineUXApp();
      //iFrame location replace is used, as we do not want to add to iFrame history.
      if (process.env.NODE_ENV==='development') {
        if(this.props.isOpenInNewWindow){
          window.open(this.props.triNavigationSrc,"_blank");
        }else{
          this.triNavigationRef.current.src = this.props.triNavigationSrc;
        }
      } else {
        if(this.props.currentMenuItemPropertyModel.isOpenInNewWindow()){
          window.open(this.props.triNavigationSrc,"_blank");
        }else{
          //Set the nav frame source                                                                            
          this.triNavigationRef.current.contentWindow.location.replace(this.props.triNavigationSrc); 
          
          //Handle initial routing history for ux inline apps, and scenarios where onchange processing did not run.
          if (this.isInLineUXApp || !this.isOnChangeProcessingComplete) {
            //Set onchange processing to true, as additional processing besides routing history is not needed.
            this.isOnChangeProcessingComplete = true;
            //Handle initial history state for inline UX Application.
            this.props.navRoutingHandler.handleRoutingHistory(this.props.navRoutingHandler.getNameFromName(this.props.triNavigationSrc), 
                                                  this.urlHashPart, 
                                                  this.isFromBrowserAction);
         }
        }  
      }
      //handle nav click complete
      this.props.handleNavClickComplete(this.triNavigationRef.current);
    }
  }

  _resetFrameOnloadFunctions() {
    //Project switcher functionality.
    this.props.resetQueryProjectSwitcherFunction(this.triNavigationRef.current);

    //Handle sub page history functionality.
    this._handleSubPageBrowserHistory();

    //Handle document title for sub page if necessary.
    this._handleDocumentTitleForSubPage();

    //Ensure landing page is visible
    this.props.showLandingPage();
  }

  _handleSubPageBrowserHistory() {
    if (this.triNavigationRef.current) {
      if (process.env.NODE_ENV!=='development') {

        //OnHashChange
        this.triNavigationRef.current.contentWindow.onhashchange = function() {
          //Handle any necessary onchange processing
          this._handleOnChangeProcessing();

          //Ensure landing page is visible
          this.props.showLandingPage();
          //Reset onchange processing complete flag
          this.isOnChangeProcessingComplete = false;
        }.bind(this);
        
        //OnPopState
        this.triNavigationRef.current.contentWindow.onpopstate = function() {
          //Ensure landing page is visible if previous Url was blank or same.
          if (this.isPreviousUrlSameOrBlank) {
            //If previous url is blank or same, first set onchange complete to false,
            //and nav click flag to false. This will ensure onChange Processing will run.
            //This scenario can happen when clicking sub-links from a homepage or nav page.
            this.isOnChangeProcessingComplete = false;
            this.isFromNavClick = false;
            this.props.showLandingPage();
          }
          //Handle any necessary onchange processing
          this._handleOnChangeProcessing();
        }.bind(this);
      }
    }
  }

  _handleOnChangeProcessing() {
    if (this.isOnChangeProcessingComplete || this.isInLineUXApp) {
      return;
    }
    let queryString = this.triNavigationRef.current.contentWindow.location.hash;
    if (!this.isFromNavClick) {
        //If not coming from nav click, handle project context logic.
        if (!this.props.navRoutingHandler.isProjectContext(queryString)) {
          queryString = this.props.navRoutingHandler.handleQueryStringForCurrentProjectId(queryString);
        }
        //Handle active menu item
        this.props.navRoutingHandler.handleActiveMenuItemForQueryString(queryString);      
    }

    //Set onchange processing to true, as additional processing besides routing history is not needed.
    this.isOnChangeProcessingComplete = true;
    this.props.navRoutingHandler.handleRoutingHistory(this.props.navRoutingHandler.getNameFromName(queryString), 
                                      queryString, 
                                      this.isFromBrowserAction);

    //If sub page is involved or not from nav click we need to handle the document title.
    if (this.props.navRoutingHandler.isSubPageBookmark(queryString) || !this.isFromNavClick) {
        //Handle document title for sub page
        this._handleDocumentTitleForSubPage();
    }

    //Reset landing page local flags.
    this.isFromNavClick = false;
    this.isFromBrowserAction = false;
  }

  _handleDocumentTitleForSubPage() {
    if (process.env.NODE_ENV!=='development') {
      if (!this.triNavigationRef.current || !this.triNavigationRef.current.contentWindow) {
        return
      }
      let queryString = this.triNavigationRef.current.contentWindow.location.hash;
      //If sub page is involved or not from nav click we need to handle the document title.
      if (this.props.navRoutingHandler.isSubPageBookmark(queryString) || !this.isFromNavClick) {
        let intervalCounter = 0;
        //Use set interval, because content frame does not appear right away.
        var checkContentFrameExists = setInterval(function() {
          let contentFrame = this.triNavigationRef.current.contentDocument.getElementById("data-auto-parent-content-frame");
          /* eslint eqeqeq: 0 */
          if (contentFrame !== null || intervalCounter === 1000) {
            if(contentFrame !== null) {
              let title = contentFrame.title;
              //If contentFrame title is blank then we need to get it from the contentDocument title.
              if (title === null || title.trim() === '') {
                document.title = this.triNavigationRef.current.contentDocument.title;
              } else {
                document.title = title + " - " + NavConfig.getNavConfigData().headerTitle;
              }
            }
            clearInterval(checkContentFrameExists);
          }
          intervalCounter++;
        }.bind(this), 1);
      }
    }
  }

  render() {
    return (  
      <div className="main-content">
        <iframe title="triNavigation" onLoad={()=>{this._resetFrameOnloadFunctions()}} ref={this.triNavigationRef} role="presentation" name="triNavigation" id="triNavigation" style={{ position: 'absolute', width: '100%', height: '100%', border: 'none', left: this.props.isRTL ? 0 : ''}}></iframe>
      </div>
    );
  }
}

export default LandingPage;
